<div class="p-d-flex p-justify-end p-mb-4">
  <div style="width: 20%">
    <kodit-magacin-lager-dropdown
      *ngIf="!isFromMagacinInfo"
      [magacinId]="filters.magacinId"
      (onItemChange)="ongMagacinChange($event)"
    ></kodit-magacin-lager-dropdown>
  </div>
</div>

<kodit-page [showCardBlock]="showCardBlock">
  <kodit-table
    *ngIf="tableConfig"
    [isTableLoading]="isLoading"
    [chipItems]="chipItems"
    [paginatedData]="paginatedData"
    [tableConfig]="tableConfig"
  >
  </kodit-table>
</kodit-page>
